import React, { useState, useEffect,useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {
    ContentContainer,
    Row,
    Col,
    Button,
    ErrorSummary,
    FormHeader,
    RadioButtonList,
    InPageAlert,
    Icon, uiIconChevronLeft
} from '@snsw-gel/react';
import { dataLayer } from '../../../services/gtm-dataLayer';
import styles from './EligibilityCheck.module.css'

const EligibilityCheckPage = () => {

    const history = useHistory();
    const [isResident, setIsResident] = useState(null);
    const [isOver60, setIsOver60] = useState(null);
    const [residentNull, setResidentNull] = useState(false);
    const [over60Null, setOver60Null] = useState(false);
    const [nonResidentError, setNonResidentError] = useState(false);
    const [ageError, setAgeError] = useState(false);
    const errorSummaryRef = useRef(null);

    useEffect(() => {
        const currentUrl = window.location.href;
        const pageName = window.location.href.split('/').pop();
        dataLayer(currentUrl, pageName);
    }, []);

    useEffect(() => {
        if (errorSummaryRef.current) {
            errorSummaryRef.current.focus();
        }
    }, [nonResidentError,ageError,residentNull,over60Null]);



    const onSubmitPage = () => {
        setResidentNull(false);
        setOver60Null(false);
        setNonResidentError(false);
        setAgeError(false);


        if (isResident === null) {
            setResidentNull(true);
            return;
        }
        if (isResident === 'false') {
            setNonResidentError(true);
            setIsOver60(null);
            return;
        }
        if (isResident === "true" && isOver60 === 'false') {
            setAgeError(true);
            return;
        }
        if (isResident === "true" && isOver60 === null) {
            setOver60Null(true);
            return;
        }
        if (isResident === 'true' && isOver60 === 'true') {
            history.push('/profileConnectRedirect');
        }

        return;
    };

    return (
        <>
            <FormHeader
                label='Apply for a NSW Seniors Card or NSW Senior Savers Card '
                title='Find out if you are eligible'
            />

            <ContentContainer className={styles['content-container']}>
                <Row>
                    <Col span={6}>
                        {residentNull &&
                           <div className={styles['error']}>
                            <ErrorSummary  ref={errorSummaryRef}
                              errors={[{ id: 'frgResident-0', text: 'Select an option to continue.' }]} />
                            </div>}
                        {over60Null &&
                            <div className={styles['error']}>
                            <ErrorSummary  ref={errorSummaryRef}
                              errors={[{ id: 'frgAge-0', text: 'Select an option to continue.' }]} />
                            </div>}

                        {nonResidentError &&
                           <div className={styles['error']} id='nonResidentError'> <InPageAlert  variant='error'
                                innerRef={errorSummaryRef}
                                tabIndex='-1'
                                role='alert'
                                title="Unfortunately you are not eligible.">
                                <p>You need to be a NSW permanent resident or citizen to be eligible for Seniors Card or Senior Savers Card. Check the <a id='nonResidentLink' target='_self' href='https://www.service.nsw.gov.au/transaction/apply-for-a-nsw-seniors-card-or-nsw-senior-savers-card#eligibility'>eligibility guidelines</a>.</p>
                            </InPageAlert>   </div>}

                        {ageError &&
                           <div className={styles['error']} id='ageError'> <InPageAlert  variant='error'
                                innerRef={errorSummaryRef}
                                tabIndex='-1'
                                role='alert'
                                title="Unfortunately you are not eligible.">
                                <p>People who are eligible include people:</p>
                                <ul>
                                    <li>aged 60 and over</li>
                                    <li>turning 60 within the next 3 weeks.</li>
                                </ul>
                                <p> Check the <a id='ageLink' target='_self' href='https://www.service.nsw.gov.au/transaction/apply-for-a-nsw-seniors-card-or-nsw-senior-savers-card#eligibility'>eligibility guidelines</a>.</p>
                            </InPageAlert>   </div>}

                            </Col>
                </Row>
                <Row>
                    <Col span={6}>
                        <RadioButtonList
                            id='frgResident'
                            name='Group Resident'
                            legend='Are you a permanent NSW resident?'
                            hasError={residentNull}
                            errorMessage='Select an option to continue.'
                            vertical={true}
                            options={[
                                { value: 'true', label: 'Yes' },
                                { value: 'false', label: 'No' },
                            ]}
                            onChange={v => {
                                setIsResident(v);
                                isResident==='true'?setIsOver60(null):"";
                             }}
                            value={isResident}
                            aria-label="required"
                        />
                        {
                            isResident==='true' &&
                            <RadioButtonList
                                aria-label='required'
                                id='frgAge'
                                name='Group Age'
                                legend='Are you aged 60 or over, or will you be 60 within the next 3 weeks?'
                                vertical={true}
                                hasError={over60Null}
                                errorMessage='Select an option to continue.'
                                options={[
                                    { value: 'true', label: 'Yes' },
                                    { value: 'false', label: 'No' },
                                ]}
                                onChange={v => setIsOver60(v)}
                                value={isOver60}
                            />
                        }
                    </Col>
                </Row>

                        <Row>
                            <Col span={12}>
                                <Button
                                    className={styles['continue-button']}
                                    id='applyButton'
                                    onClick={onSubmitPage}
                                    aria-label='Continue'
                                >
                                    Continue
                                </Button>
                            </Col>
                        </Row>

                        <Row>
                            <Col span={12}>
                                <Button
                                    iconStart={<Icon icon={uiIconChevronLeft} />}
                                    className={styles['back-link']}
                                    variant="link"
                                    as={Link}
                                    href='/'
                                    aria-label='Go back'
                                >
                                    Back
                                </Button>
                            </Col>
                        </Row>


            </ContentContainer>
        </>
    );
};

export default EligibilityCheckPage;

